// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"6cce0f54","977":"3241a5b2"}[chunkId] + ".chunk.js";
};